<template>
    <header :class="{scrolling: pos || $route.name == 'LegalNotices' || $route.name == 'CGV'}">
        <div class="header-container">
            <div class="logo-container">
                <router-link to="/#top">
                    <div class="logo-desk">
                        <img src="./../assets/logo_rivha_pilates.png" alt="logo MPS" />
                    </div>
                </router-link>
            </div>
            <!-- <div class="menu-container">
                <nav class="menu-desk">
                    <router-link class="menu-link" to="/#cours">Les cours</router-link>
                    <router-link class="menu-link" to="/#contact">Contact</router-link>
                </nav> -->
                        <!-- MENU RESP -->
                <!-- <div class="menu-header-resp">
                    <div class="burger-nav" @click="open = !open" :class="open ? 'open' : ''" >
                        <span></span>
                        <span></span>
                        <span></span>
                        <span></span>
                    </div>
                    <nav class="menu-header-resp-content" v-if="open">
                        <router-link class="menu-link" to="/#cours" @click="open = false">Les cours</router-link>
                        <router-link class="menu-link" to="/#contact" @click="open = false">Contact</router-link>                        
                    </nav>
                </div>
            </div> -->
            <input class="checkbox" type="checkbox" name="" id="menu-checkbox" />
            <div class="hamburger-lines">
              <span class="line line1"></span>
              <span class="line line2"></span>
              <span class="line line3"></span>
            </div>

            <div class="menu-items">
                <router-link to="/#cours" class="menu-link" @click="closeMenu()">Séances</router-link>
                <router-link to="/#contact" class="menu-link" @click="closeMenu()">Contact</router-link>
            </div>
        </div>
    </header>
</template>

<script>
export default {
    name : "HeaderApp",
    data() {
        return {
            pos : false,
            open: false
        }
    },
    mounted() {
        window.addEventListener('scroll', this.handleScroll);
        this.open = false;
    },
    beforeUnmount() {
        window.removeEventListener('scroll', this.handleScroll);
    },
    methods : {
        handleScroll() {   
            window.scrollY > 0 ? this.pos = true : this.pos = false;
        },
        closeMenu(){
            this.open = false;
            document.getElementById("menu-checkbox").checked = false; 
        }
    }
}
</script>

<style scoped lang="scss">
@import "./../scss/variables.scss";

header {
    height:120px;
    display: flex;
    justify-content: center;
    align-items: center;
    transition:0.5s;
    position: fixed;
    top:0;
    width: 100%;
    background: transparent;
    z-index:99;
}

header.scrolling {
    background:$mainColor;
    box-shadow: 3px 0 5px 5px rgba(0,0,0,0.2);
    height:80px;
}

.header-container {
    width:$box;
    max-width: 90%;
    display: flex;
    align-items: center;
    justify-content: space-between;
}

header.scrolling img {
  max-height: 60px;
  width: auto;
}

img {
   width:320px;
   height:auto; 
}

.checkbox {
  position: absolute;
  display: block;
  height: 32px;
  width: 32px;
  top: 20px;
  right: 20px;
  z-index: 5;
  opacity: 0;
  cursor: pointer;
}

.hamburger-lines {
  display: block;
  height: 26px;
  width: 32px;
  position: absolute;
  top: 27px;
  right: 30px;
  z-index: 2;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.hamburger-lines .line {
  display: block;
  height: 4px;
  width: 100%;
  border-radius: 10px;
  background: $secondaryColor;
}

header.scrolling .hamburger-lines .line {
  background: $secondaryColor;
}


.hamburger-lines .line1 {
  transform-origin: 0% 0%;
  transition: all 0.4s ease-in-out;
}

.hamburger-lines .line2 {
  transition: all 0.2s ease-in-out;
}

.hamburger-lines .line3 {
  transform-origin: 0% 100%;
  transition: all 0.4s ease-in-out;
}

.menu-items {
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    transition: all 0.5s ease-in-out;
    text-align: center;
    position:fixed;
    top:0;
    left:100%;
    bottom:0;
    background: rgba($secondaryColor, 0.9);
}

input[type="checkbox"]:checked ~ .menu-items {
  //transform: translateX(0);
  left:0;
}

input[type="checkbox"]:checked ~ .hamburger-lines .line1 {
  transform: rotate(45deg);
  background: $mainColor;
}

input[type="checkbox"]:checked ~ .hamburger-lines .line2 {
  transform: scaleY(0);
  background: $mainColor;
}

input[type="checkbox"]:checked ~ .hamburger-lines .line3 {
  transform: rotate(-45deg);
  background: $mainColor;
}

.menu-link {
  text-decoration: none;
  color: $mainColor;
  font-size: 25px;
  padding: 0.7rem;
  text-transform: uppercase;
  border-bottom: 2px solid transparent;
  margin:10px auto;
  letter-spacing: 1px;
}


.menu-link:hover {
    border-color: $mainColor;
}

@media screen and (max-width:768px) {
  img {
    height: 60px;
    width: auto;
  }
}


</style>

